/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_View_ListInputs */

const en_home_v2_view_list = /** @type {(inputs: Home_V2_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List view`)
};

const es_home_v2_view_list = /** @type {(inputs: Home_V2_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de lista`)
};

/**
* | output |
* | --- |
* | "List view" |
*
* @param {Home_V2_View_ListInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_view_list = /** @type {((inputs?: Home_V2_View_ListInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_View_ListInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_view_list(inputs)
	return en_home_v2_view_list(inputs)
});